import type { Value, PointTarget, GeometryElementDisplayConfig } from '../../../geometrypad.model';

// =============================================================================
// TYPES
// =============================================================================

/** Circle construction format (used for explicit format override; auto-detected when omitted) */
export type CircleFormat = 'CR' | 'DP';

export interface CircleElement {
  type: 'Circle';
  params: {
    r?: Value;
    center?: PointTarget;
    diameterA?: PointTarget;
    diameterB?: PointTarget;
  };
  names?: { r?: string; d?: string };
}

// =============================================================================
// DISPLAY DEFAULTS
// =============================================================================

/**
 * Default display theme for circles.
 */
export const CIRCLE_DEFAULTS: GeometryElementDisplayConfig = {
  circle: { strokeColor: 'sky', fillOpacity: 0, strokeWidth: 2 },
  point: { color: 'sky', size: 4 },
  subparts: {
    center: { point: { color: 'sky' } },
  },
};
